import { ItemScheme } from '../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../Enums/MagicField.enum';

export const HealthPlanMonitoringBabyLatamTesting: ItemScheme[] = [
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamVaginalBleeding',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.vaginalBleeding',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				value: 'meddiBabyLatamVaginalBleeding',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamTemperature',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.temperature',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamTemperature',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamWeight',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.weight',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamWeight',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamUrinaryTractInfection',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.signsOfUrinaryInfection',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamUrinaryTractInfection',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamVaginalInfection',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.signsOfVaginalInfection',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamVaginalInfection',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamVomiting',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.vomiting',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamVomiting',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamDiarrhoea',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.diarrhealPictures',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamDiarrhoea',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamSwelling',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.edema',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamSwelling',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamMedicaments',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.medicationReaction',
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamMedicaments',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamBloodpresure',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.arterialPressure.text',
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamBloodpresure',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamGlycemia',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.glycemia.text',
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamGlycemia',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamHypertensionSymptoms',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.hypertensionSymptoms.text',
				defaultValue: true,
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamHypertensionSymptoms',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamAmnioticFluidLeak',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.amnioticFluidLeak',
				defaultValue: true,
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamAmnioticFluidLeak',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamFetalMovements',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.fetalMovements',
				defaultValue: true,
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamFetalMovements',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamUterineContractions',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.uterineContractions',
				defaultValue: true,
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamUterineContractions',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamLochia',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.lochia',
				defaultValue: true,
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamLochia',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamLowerAbdomenPain',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.lowerAbdomenPain',
				defaultValue: true,
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamLowerAbdomenPain',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamRouteOfDelivery',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.routeOfDelivery',
				defaultValue: true,
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.15days',
					},
				},
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamRouteOfDelivery',
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'meddiBabyLatamBreastSelfAssessment',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'component.monitoring.baby.breastSelfAssessment',
				defaultValue: true,
				settings: {
					tooltip: {
						content: 'component.monitoring.baby.frequency.4days',
					},
				},
			},
			{
				type: MagicField.TEXT_FIELD,
				key: 'questionnaireCode',
				settings: {
					hidden: true,
				},
				defaultValue: 'meddiBabyLatamBreastSelfAssessment',
			},
		],
	},
];
